import type { ButtonProps } from 'antd';
import { Button } from 'antd';
import type { FC } from 'react';
import { useEffect, useRef } from 'react';

export const TableCreationButton: FC<ButtonProps> = (props) => {
  // ref
  const buttonRef = useRef<HTMLButtonElement>(null);
  // effect
  useEffect(
    () =>
      buttonRef.current?.scrollIntoView({
        behavior: 'smooth',
        inline: 'nearest',
      }),
    [],
  );

  return (
    <Button {...props} block ref={buttonRef}>
      添加字段
    </Button>
  );
};
